class SliderComponentCustom extends HTMLElement {
  connectedCallback() {
    const thumbsSwiperEl = this.querySelector('.mySwiper2');
    const mainSwiperEl = this.querySelector('.mySwiper');
    if (!thumbsSwiperEl) return;

    const galleryThumbs = new Swiper(thumbsSwiperEl, {
      spaceBetween: 30,
      slidesPerView: 4,
      loop: false,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      breakpoints: {
        0: { slidesPerView: 2, slidesPerGroup: 1 },
        480: { slidesPerView: 3, slidesPerGroup: 1 },
        768: { slidesPerView: 4, slidesPerGroup: 1 },
        1024: { slidesPerView: 4, slidesPerGroup: 1 },
      },
    });

    // Init main slider
    const galleryTop = new Swiper(mainSwiperEl, {
      spaceBetween: 10,
      loop: true,
      loopedSlides: 5,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  }
}

customElements.define('featured-product-custom', SliderComponentCustom);
